module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class=\'drop-zone-field\' id=\'invoice-drop-target\'>\n    ' +
((__t = ( WiseMetering.icon('upload', 'drop-zone-field-icon') )) == null ? '' : __t) +
'\n    <span>' +
((__t = ( i18next.t('invoices.drop_or_browse') )) == null ? '' : __t) +
'</span>\n    <span class=\'drop-zone-field-hint\'>' +
((__t = ( i18next.t('invoices.upload_hint', { count: maxFiles }) )) == null ? '' : __t) +
'</span>\n</div>\n<input accept=\'application/pdf\' id=\'invoice-files\' multiple style=\'display: none\' type=\'file\'/>\n<ul class=\'drop-zone-file-list\' id=\'invoice-file-list\'></ul>\n';

}
return __p
}